export default __webpack_public_path__ + "static/media/plattform_reflection_blur.98a6603a.png";